module.exports = __webpack_public_path__ + "img/oufu_70x90x10b.prt.546b791c.jpg";